import { useState } from "react";
import {auth, db} from '../FirebaseConfig';
import { Button, Form, Col } from "react-bootstrap";
import firebase from 'firebase';

const SignUp = ({setUname}) => {
    const [email, setEmail] = useState('');
    const [nickname, setNickname] = useState('');
    const [password, setPassword] = useState('');
    const [addr1, setAddr1] = useState('');
    const [addr2, setAddr2] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    
    const signUp = (e) =>{
        e.preventDefault();

        try{
            auth.createUserWithEmailAndPassword(email, password)
            .then((authUser) => {
                return authUser.user.updateProfile({
                    displayName : nickname
                });
            }).catch((err) => alert(err.message));
            setUname(nickname);

            if (email !== '' && addr1 !== '' && addr2 !== '' && city !== '' && state !== '' && zip !== '') {
                db.collection('USERS').add({
                    timestamp : firebase.firestore.FieldValue.serverTimestamp(),
                    user_email : email,
                    user_addr1 : addr1,
                    user_addr2 : addr2,
                    user_city : city,
                    user_state : state,
                    user_zip : zip
                    })
            }
        }

        catch(error){
            alert(error.message);
        }
        
    }

    return(
        <div className = 'signup'>
            <h4>Sign Up your Profile</h4>
            <Form className = 'signupForm'>
                <Form.Row>
                    <Form.Group as={Col} controlId="formGridNickname">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter Nick Name"
                            value = {nickname}
                            onChange = {(e) => setNickname(e.target.value)}/>
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} md controlId="formGridEmail">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control type="email" placeholder="Enter email"
                            value = {email}
                            onChange = {(e) => setEmail(e.target.value)}/>
                        <Form.Text className = 'text-muted'>
                            We'll never share your email with anyone else.
                        </Form.Text>
                    </Form.Group>
                    
                    <Form.Group as={Col} md controlId="formGridPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" placeholder="Password"
                            value = {password}
                            onChange = {(e) => setPassword(e.target.value)}/>
                    </Form.Group>
                </Form.Row>

                <Form.Group controlId="formGridAddress1">
                    <Form.Label>Address</Form.Label>
                    <Form.Control placeholder="Apt No, Society"
                        value = {addr1}
                        onChange = {(e) => setAddr1(e.target.value)} />
                </Form.Group>

                <Form.Group controlId="formGridAddress2">
                    <Form.Label>Address 2</Form.Label>
                    <Form.Control placeholder="Road, Town" 
                        value = {addr2}
                        onChange = {(e) => setAddr2(e.target.value)} />
                </Form.Group>

                <Form.Row>
                    <Form.Group as={Col} md controlId="formGridCity">
                        <Form.Label>City</Form.Label>
                        <Form.Control
                            value = {city}
                            onChange = {(e) => setCity(e.target.value)} />
                    </Form.Group>

                    <Form.Group as={Col} md controlId="formGridState">
                        <Form.Label>State</Form.Label>
                        <Form.Control
                            value = {state}
                            onChange = {(e) => setState(e.target.value)} />
                    </Form.Group>

                    <Form.Group as={Col} md controlId="formGridZip">
                        <Form.Label>Zip</Form.Label>
                        <Form.Control
                            value = {zip}
                            onChange = {(e) => setZip(e.target.value)} />
                    </Form.Group>
                </Form.Row>

                <Button variant="dark" type="submit" onClick = {signUp}>
                    Submit
                </Button>
            </Form>
        </div>
    );
}

export default SignUp;